(()=>{
  if(!document.querySelector('[data-it-gemstone-shell]'))return;

  const grades=['Visibly Included','Moderately Included','Slightly Included','Eye Clean'];
  const norm=v=>(v||'').replace(/\s+/g,' ').trim().toLowerCase();
  const gradeSet=new Set(grades.map(norm));

  const enhanceClarity=()=>{
    const candidates=[...document.querySelectorAll('span,small,label,button,[role="button"],[role="option"]')]
      .filter(el=>gradeSet.has(norm(el.textContent)));
    if(candidates.length<4)return;

    const unique=grades.map(label=>candidates.find(el=>norm(el.textContent)===norm(label))).filter(Boolean);
    if(unique.length<4)return;

    let group=unique[0].parentElement;
    let depth=0;
    while(group&&group!==document.body&&depth<8){
      const containsAll=unique.every(el=>group.contains(el));
      const text=norm(group.textContent);
      if(containsAll&&text.includes('clarity')&&text.length<1800)break;
      group=group.parentElement;
      depth++;
    }
    if(!group||group===document.body)return;

    group.classList.add('it-gemstone-native-clarity');
    unique.forEach(el=>{
      if((el.tagName==='SPAN'||el.tagName==='SMALL')&&el.children.length===0){
        el.classList.add('it-gemstone-native-clarity-label');
      }
    });

    if(group.querySelector('[data-it-gemstone-clarity-guide]'))return;
    const guide=document.createElement('div');
    guide.className='it-gemstone-native-clarity-guide';
    guide.dataset.itGemstoneClarityGuide='';
    guide.setAttribute('aria-label','Clarity scale from included to eye clean');
    grades.forEach(label=>{
      const span=document.createElement('span');
      span.textContent=label;
      guide.appendChild(span);
    });
    const note=document.createElement('p');
    note.className='it-gemstone-native-clarity-note';
    note.textContent='Clarity terminology varies by gemstone type; natural inclusions can be normal for many coloured gemstones.';
    guide.appendChild(note);
    group.appendChild(guide);
  };

  let queued=false;
  const schedule=()=>{
    if(queued)return;
    queued=true;
    requestAnimationFrame(()=>{queued=false;enhanceClarity();});
  };

  enhanceClarity();
  new MutationObserver(schedule).observe(document.body,{subtree:true,childList:true});
})();